import { Button, Flex, Text } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { WorkspaceModal } from '../AnalysisWorkspace/components/primitives/WorkspaceModal';

/** The prototype's confirm dialog width. */
const CONFIRM_WIDTH = 460;

interface Props {
	opened: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

/** "Delete this batch?": the purge cannot be undone. It can open over the ingestion modal, which it then covers. */
export const DeleteBatchConfirmModal = ({ opened, onCancel, onConfirm }: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<WorkspaceModal
			opened={opened}
			onClose={onCancel}
			title={tCapManage('dealstack_ai.batch_delete.confirm.title')}
			centered
			size={CONFIRM_WIDTH}
			testId={TEST_ELEMENT_IDS.DEALSTACK_AI_DELETE_BATCH_BUTTON_CONFIRM_DIALOG}
		>
			{/* The confirm's paragraph in the design's secondary ink (`.fg2`). */}
			<Text component="p" m={0} c="dark.0" fz="md" lh="20px">
				{tCapManage('dealstack_ai.batch_delete.confirm.body')}
			</Text>
			<Flex
				justify="flex-end"
				gap={12}
				mt="xs"
				mx={-24}
				mb={-24}
				py="sm"
				px="md"
				style={{ borderTop: '1px solid var(--mantine-color-gray-2)' }}
			>
				<Button
					variant="tertiary"
					onClick={onCancel}
					data-autofocus
					data-testid={TEST_ELEMENT_IDS.DEALSTACK_AI_DELETE_BATCH_BUTTON_CONFIRM_CANCEL}
				>
					{tCapManage('common.cancel')}
				</Button>
				<Button
					variant="deletion"
					onClick={onConfirm}
					data-testid={TEST_ELEMENT_IDS.DEALSTACK_AI_DELETE_BATCH_BUTTON_CONFIRM}
				>
					{tCapManage('dealstack_ai.batch_delete.button')}
				</Button>
			</Flex>
		</WorkspaceModal>
	);
};
